// De invulplekken die een brief-sjabloon mag gebruiken ({{organisatie}} enz.),
// per soort brief: voor/na (bij een onderzoek), output (bij een
// registratieformulier — daar is geen onderzoek of meetmoment) en storytelling
// (bij een storytelling-deellink — alleen de organisatie).
//
// De server weigert bij het klaarzetten van een sjabloon elke andere plek
// (functions/letters/letterTemplates.js, PLACEHOLDERS_BY_KIND); de briefpagina vult er
// precies deze in. Een pariteitstest in functions/ houdt de twee gelijk.
// AI-CONTEXT: See docs/pitfalls.md#dev-mirrored-constant-guarded-only-by-a-comment

const RESEARCH_PLACEHOLDERS = ['organisatie', 'onderzoek', 'meetmoment', 'adresstap']

const LETTER_PLACEHOLDERS = {
    voor: RESEARCH_PLACEHOLDERS,
    na: RESEARCH_PLACEHOLDERS,
    output: ['organisatie', 'activiteit'],
    storytelling: ['organisatie'],
}

export default LETTER_PLACEHOLDERS
